import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import Menu, {
    centeredAnchorOrigin,
    centeredTransformOrigin
} from "components/DesignComponents/Menu";

import { FilterMenuProps } from "./types";

const FilterMenu = ({
    isOpen,
    anchorEl,
    children,
    onClose
}: FilterMenuProps) => {
    const { gray700 } = colors;

    const { t } = useTranslation();

    return (
        <Menu
            open={isOpen}
            onClose={onClose}
            anchorEl={anchorEl}
            slotProps={{
                list: {
                    variant: "menu"
                }
            }}
            anchorOrigin={centeredAnchorOrigin}
            transformOrigin={centeredTransformOrigin}
            css={css({
                "& .MuiMenu-paper": {
                    minWidth: "276px"
                }
            })}
        >
            <div
                css={css({
                    padding: "15px"
                })}
            >
                <div
                    css={css({
                        color: gray700,
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "20px",
                        letterSpacing: "0.1px",
                        marginBottom: "16px"
                    })}
                >
                    {t("Filter##table filters")}
                </div>

                {children}
            </div>
        </Menu>
    );
};

export default FilterMenu;
